import React, { useState, useContext, createContext, useEffect } from "react";
import { User } from "./model/User";

const axios = require('axios').default;

const authContext = createContext({
    user: new User() || undefined,
    setUser: (user: User) => {},

    selectedCountry: undefined as string | undefined,
    setSelectedCountry: (country: string | undefined) => {},

    selectedBreed: "" as string | undefined,
    setSelectedBreed: (breed: string | undefined) => {},

    availableBreeds: [] as Array<any> | undefined,
    setAvailableBreeds: (breeds: Array<any>) => {},

    signin: (user: any, password: any): Promise<Object> => { return new Promise<Object>((resolve, reject) => { resolve({}); }); },
    signout: (): Promise<void> => { return new Promise<void>((resolve, reject) => { resolve(); }); },

    isSysadmin: (): boolean => { return false; },
    isSelectedBreedAdmin: (): boolean => { return false; },
});

export function ProvideAuth({ children }: any) {
    const auth = useProvideAuth();
    return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

export const useAuth = () => {
    return useContext(authContext);
};

function useProvideAuth() {
    const [user, setUser] = useState<User>({
        auth: false,
        token: "",
        userdata: undefined,
    });

    const [selectedCountry, setSelectedCountryValue] = useState<string | undefined>(undefined);
    const [selectedBreed, setSelectedBreedValue] = useState<string | undefined>(undefined);
    const [availableBreeds, setAvailableBreeds] = useState<Array<any>>([]);

    function setSelectedBreed(breed: string | undefined) {
        setSelectedBreedValue(breed);
        // Save to localstorage
        localStorage.setItem("selectedBreed", breed || "");
    }

    function setSelectedCountry(country: string | undefined) {
        setSelectedCountryValue(country);
        // Save to localstorage
        localStorage.setItem("selectedCountry", country || "");
    }
    
    if (user.token == "" && localStorage.getItem("logindata") != null) {
        setUser(JSON.parse(localStorage.getItem("logindata") || ""));
    }

    function isSysadmin() {
        if (user.userdata != undefined) {
            return user.userdata.ROLE == "sysadmin";
        }
        return false;
    }

    function isSelectedBreedAdmin() {
        let councilAccess = user.userdata?.COUNCIL_ACCESS?.find((council: any) => council.BREED_ID == selectedBreed);
        if (councilAccess) {
            return councilAccess.ACCESSLEVEL == "admin";
        }
        return false;
    }

    async function signin(email: string, password: string) {
        return new Promise<Object>(async (resolve, reject) => {
            let logindata: any;

            await axios.post('/api/login', {
                email: email,
                password: password
            })
            .then(function (response: any) {
                logindata = response.data;
                localStorage.setItem('logindata', JSON.stringify(logindata));
                setUser(logindata);
                if (logindata.userdata?.MAIN_BREED_ID) {
                    setSelectedBreed(String(logindata.userdata.MAIN_BREED_ID));
                }
                resolve(logindata);
            })
            .catch(function (error: any) {
                reject(error);
            });
        });
    };

    function signout() {
        return new Promise<void>(async (resolve, reject) => {
            localStorage.removeItem("logindata");
            localStorage.removeItem("selectedBreed");
            localStorage.removeItem("selectedCountry");
            setUser(new User());
            resolve();
        });
    };

    useEffect(() => {
        function checkUserData() {
            const item = localStorage.getItem('logindata');
            if (item) {
                setUser({
                    ...user,
                    ...JSON.parse(item)
                });
            }
        }
        function checkSelectedBreed() {
            // Check if selectedBreed is set
            const item2 = localStorage.getItem('selectedBreed');
            if (item2) {
                setSelectedBreedValue(item2);
            }
        }
        function checkSelectedCountry() {
            // Check if selectedCountry is set
            const item3 = localStorage.getItem('selectedCountry');
            if (item3) {
                setSelectedCountryValue(item3);
            }
        }
      
        // Login and logout follow other tabs. Breed and country do not: each tab
        // keeps its own, and only starts from the last one chosen. Syncing them
        // made a tab on a dog page (which sets the breed to its dog's) switch
        // the other tabs back.
        window.addEventListener('storage', checkUserData);

        checkSelectedBreed();
        checkSelectedCountry();

        return () => {
            window.removeEventListener('storage', checkUserData);
        }
    }, [])

    return {
        user,
        setUser,
        selectedCountry,
        setSelectedCountry,
        selectedBreed,
        setSelectedBreed,
        availableBreeds,
        setAvailableBreeds,
        signin,
        signout,
        isSysadmin,
        isSelectedBreedAdmin,
    };
}